import React, { Component } from 'react';
import { RandomizedUserBadgeColors } from '../constants';
// @ts-ignore
import EditIcon from '../assets/icons/edit.svg';
// @ts-ignore
import CloseIcon from '../assets/icons/close.svg';
// @ts-ignore
import AddQueue from '../assets/icons/add.svg';
import Modal from '../CommonComponents/Modal';
import AddingNewUser from './AddingNewUser';
import { api } from '../utils';
import AddExistingUser from './AddExistingUser';
import EditUserModal from './EditUserModal';
import DeleteUserModal from './DeleteUserModal';

type Props = {
  selectedBotid: string;
  tenantId: number;
  toasterNotify: Function;
};

type State = {
  newArray: {
    userName: string;
    email: string;
    queues: string;
    id: number;
    check: boolean;
    agentId: string;
    currentQuest: any;
    RoleName: string;
    RoleId: number;
    firstName: string;
    lastName: string;
  }[];
  adminCount: number;
  showSelectionOfUser: boolean;
  addNewAgent: boolean;
  showAddExistingUser: boolean;
  showAdminAnalystSelection: boolean;
  shwAdminAnalystExisting: boolean;
  shwAdminAnalystNewUser: boolean;
  editRoleModal: boolean;
  editUserDetails: { username: string; email: string; roltype: string }[];
  shwDeleteModal: boolean;
  deteleUser: string;
  deleteOrigin: string;
  editOrigin: string;
  userList: {
    userName: string;
    email: string;
    queues: string;
    id: number;
    check: boolean;
    agentId: string;
    currentQuest: any;
    RoleName: string;
    RoleId: number;
  }[];
  editAgent: string;
  deleteAgent: string;
  adminAnalystData: {
    userName: string;
    email: string;
    queues: string;
    id: number;
    check: boolean;
    agentId: string;
    currentQuest: any;
    RoleName: string;
    RoleId: number;
    firstName: string;
    lastName: string;
  }[];
};

export default class TeamTab extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.checkEmailValidation = this.checkEmailValidation.bind(this);
    this.addNewUser = this.addNewUser.bind(this);
    this.editRole = this.editRole.bind(this);
    this.saveEditDetails = this.saveEditDetails.bind(this);
    this.shwDeleteModal = this.shwDeleteModal.bind(this);
    this.RemoveUser = this.RemoveUser.bind(this);
    this.fetchAgentList = this.fetchAgentList.bind(this);
    this.userPreviousCheck = this.userPreviousCheck.bind(this);
  }
  setInitialState(): State {
    return {
      showSelectionOfUser: false,
      addNewAgent: false,
      showAddExistingUser: false,
      showAdminAnalystSelection: false,
      shwAdminAnalystExisting: false,
      shwAdminAnalystNewUser: false,
      editRoleModal: false,
      editUserDetails: [],
      shwDeleteModal: false,
      deteleUser: '',
      deleteOrigin: '',
      editOrigin: '',
      userList: [],
      editAgent: '',
      deleteAgent: '',
      adminAnalystData: [],
      adminCount: 0,
      newArray: [],
    };
  }
  componentDidMount() {
    this.fetchAgentList();
  }
  componentDidUpdate(prevProps: Props, _: State) {
    if (this.props.selectedBotid !== prevProps.selectedBotid) {
      this.fetchAgentList();
    }
  }
  // userPreviousCheck(val: string) {
  //   var response = false;
  //   this.state.adminAnalystData.forEach((data: any, i: number) => {
  //     if (data.email === val) {
  //       console.log('added');
  //       response = true;
  //     } else {
  //       response = false;
  //     }
  //   });
  //   return response;
  // }
  userPreviousCheck(val: string) {
    // console.log(val);
    var data = this.state.adminAnalystData.filter((elem) => elem.email === val);
    this.setState(
      {
        newArray: data,
      },
      () => {
        // console.log(this.state.newArray);
      }
    );
  }

  fetchAgentList() {
    api(
      `getAgentsList?botId=${encodeURIComponent(this.props.selectedBotid)}&tenantId=${
        this.props.tenantId
      }&tabName=team`
    ).then((response) => {
      response.agents = response.agents.sort(function (agent1: any, agent2: any) {
        return agent1.RoleId === 6 ? -1 : agent2.RoleId === 6 ? 1 : 0;
      });
      let count = 0;
      response.agents.forEach(function (agent: any) {
        if (agent.RoleId === 6) {
          count++;
        }
      });
      this.setState({
        adminAnalystData: response.agents.map((res: any, index: number) => {
          return {
            userName: res.userName,
            email: res.EmailId,
            queues: res.currentQuest,
            id: index,
            check: false,
            agentId: res.AgentId,
            currentQuest: res.currentQuest,
            RoleName: res.RoleName,
            RoleId: res.RoleId,
            firstName: res.firstName,
            lastName: res.lastName,
          };
        }),
        adminCount: count,
      });
    });
  }
  addNewUser(
    email: string,
    frstName: string,
    lastName: string,
    selectedQueueList?: any,
    roleType?: string
  ) {
    let finalQueueList = selectedQueueList.filter((data: any) => data.check === true);
    let queueIds: any = [];
    finalQueueList.map((data: any) => {
      queueIds.push(data.queueId);
    });
    let value = this.checkEmailValidation(email);
    let frstvalidName = this.checkNameValidation(frstName);
    let lastvalidName = this.checkNameValidation(lastName);
    if (value && frstvalidName && lastvalidName) {
      api('createUser', 'POST', {
        userEmail: email,
        firstName: frstName,
        lastName: lastName,
        roleName: roleType ? roleType : 'Agent',
        tab: 'team',
        // botId: encodeURIComponent(this.props.selectedBotid),
        botId: this.props.selectedBotid,
        agentId: sessionStorage.getItem('agentId'),
      }).then((res) => {
        if (res.msg === 'User added') {
          this.setState({
            addNewAgent: false,
            shwAdminAnalystNewUser: false,
            showSelectionOfUser: false,
            shwAdminAnalystExisting: false,
          });
          this.fetchAgentList();
        } else if (res.msg === 'User already added') {
          let username = frstName + ' ' + lastName;
          this.editRole(username, email, 'Agent', '', res.agentId);
          this.setState({
            addNewAgent: false,
            shwAdminAnalystNewUser: false,
            showSelectionOfUser: false,
          });
        }
        this.props.toasterNotify(res.msg);
      });
    } else if (value === false) {
      let mailValidation = document.getElementById('mail-validation-error');
      if (mailValidation) {
        mailValidation.innerHTML = 'Invalid email address, please try again';
      }
      // alert('Please enter a valid Email-id');
      return false;
    } else if (frstvalidName === false) {
      let fnameValidation = document.getElementById('fname-validation-error');
      if (fnameValidation) {
        fnameValidation.innerHTML = 'Please enter a valid First Name';
      }
      return false;
    } else if (lastvalidName === false) {
      let lnameValidation = document.getElementById('lname-validation-error');
      if (lnameValidation) {
        lnameValidation.innerHTML = 'Please enter a valid Last Name';
      }
      return false;
    }
  }
  checkEmailValidation(email: string) {
    var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (re.test(email)) {
      return true;
    } else {
      let mailValidation = document.getElementById('mail-validation-error');
      if (mailValidation) {
        mailValidation.innerHTML = 'Invalid email address, please try again';
      }
      return false;
    }
  }
  // checkNameValidation(name: string) {
  //   var regex = /^[a-zA-Z ]{1,30}$/;
  //   if (regex.test(name)) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  checkNameValidation(name: string) {
    var regex = /^[a-zA-Z0-9 ]{2,30}$/; //nosonar
    //  var regex=/^[a-z0-9_\.]+$/;
    var spaceRegex = /\s{5,}/;
    if (name && regex.test(name.trim()) && !spaceRegex.test(name.trim())) {
      return true;
    } else {
      // alert('This doesn’t seem like a name, please try again');
      return false;
    }
  }
  editRole(
    username: string,
    email: string,
    role: string,
    currentQuest?: any,
    agentId?: string
  ) {
    this.setState({
      editRoleModal: !this.state.editRoleModal,
      editUserDetails: [{ username: username, email: email, roltype: role }],
      editOrigin: role,
      editAgent: agentId ? agentId : '',
    });
  }
  saveEditDetails(roleType: string, msg: string) {
    this.props.toasterNotify(msg);
    if (msg === 'Changes saved') {
      this.setState({
        editRoleModal: false,
      });
      this.fetchAgentList();
    }
  }
  shwDeleteModal(username: string, origin: string, agentId?: string) {
    this.setState({
      shwDeleteModal: !this.state.shwDeleteModal,
      deteleUser: username,
      deleteOrigin: origin,
      deleteAgent: agentId ? agentId : '',
    });
  }
  RemoveUser() {
    let data = {
      // botId: encodeURIComponent(this.props.selectedBotid),
      botId: this.props.selectedBotid,
      agentId: this.state.deleteAgent,
      roleName: this.state.deleteOrigin,
    };
    api('deleteUser', 'POST', data).then((res) => {
      if (res.msg === 'Agent removed') {
        this.setState({
          shwDeleteModal: !this.state.shwDeleteModal,
        });
        this.fetchAgentList();
      }
      this.props.toasterNotify(res.msg);
    });
  }
  render() {
    return (
      <>
        <div>
          <div className='queues-header'>
            <div className='queues'>Team</div>
            <div
              className='create-queue'
              onClick={() => {
                this.setState({
                  shwAdminAnalystExisting: !this.state.shwAdminAnalystExisting,
                });
              }}>
              <img src={AddQueue} alt='add queue' />
              Add user
            </div>
          </div>
          <div className='add-user-list'>
            <div className='header-wrapper'>
              <div className='header-content'>User</div>
              <div className='header-content'>Role</div>
            </div>
            <div
              className='content-wrapper team-tab'
              style={{
                maxHeight: 'calc(100vh - 350px)',
              }}>
              {this.state.adminAnalystData.length > 0 ? (
                this.state.adminAnalystData.map((userdata, i) => {
                  return (
                    <div
                      className={`content-sub-wrapper ${
                        userdata.RoleId === 6 ? 'admin-box' : ''
                      } ${this.state.adminCount - 1 === i ? 'last-admin-box' : ''}`}
                      key={userdata.id}>
                      <div className='frst-wrapper'>
                        <div
                          style={{
                            backgroundColor:
                              // RandomizedUserBadgeColors[
                              //   userdata.userName[0].toLocaleLowerCase().charCodeAt(0) %
                              //     97
                              // ],

                              RandomizedUserBadgeColors[
                                (userdata.lastName[0]
                                  ? userdata.lastName[0]
                                  : userdata.firstName[0]
                                )
                                  .toLowerCase()
                                  .charCodeAt(0) % 97
                              ],
                          }}
                          className='user-badge'>
                          {userdata.userName[0]}
                        </div>
                        <div className='user-details'>
                          <span style={{ textTransform: 'capitalize' }}>
                            {userdata.userName}{' '}
                            {userdata.email === sessionStorage.getItem('userEmail')
                              ? '(You)'
                              : null}
                          </span>
                          <span className='break-data'>{userdata.email}</span>
                        </div>
                      </div>
                      <div
                        className='second-wrapper'
                        style={{
                          display: 'flex',
                          width: '50%',
                          justifyContent: 'space-between',
                        }}>
                        <div>{userdata.RoleName}</div>
                        {userdata.RoleId === 6 ||
                        userdata.email === sessionStorage.getItem('userEmail') ? (
                          ''
                        ) : (
                          <div style={{ marginRight: '40px' }}>
                            <img
                              src={EditIcon}
                              style={{ marginRight: '35px', cursor: 'pointer' }}
                              onClick={() => {
                                this.editRole(
                                  userdata.userName,
                                  userdata.email,
                                  userdata.RoleName,
                                  userdata.currentQuest,
                                  userdata.agentId
                                );
                              }}
                              alt='edit icon'
                            />
                            <img
                              src={CloseIcon}
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                this.shwDeleteModal(
                                  userdata.userName,
                                  userdata.RoleName,
                                  userdata.agentId
                                );
                              }}
                              alt='close icon'
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div style={{ color: 'rgba(0, 0, 0, 0.6)', marginTop: '20px' }}>
                  No Admin/Analyst added yet
                </div>
              )}
            </div>
          </div>
        </div>
        <Modal
          title='Add new user'
          isOpen={this.state.addNewAgent || this.state.shwAdminAnalystNewUser}
          onClose={() => {
            this.setState({
              addNewAgent: false,
              shwAdminAnalystNewUser: false,
            });
          }}>
          <AddingNewUser
            addNewUser={this.addNewUser}
            onClose={() => {
              this.setState({
                addNewAgent: false,
                shwAdminAnalystNewUser: false,
                newArray: [],
              });
            }}
            src='team tab'
            origin={this.state.shwAdminAnalystNewUser ? 'admin-analyst' : ''}
            selectedBotId={this.props.selectedBotid}
            userPreviousCheck={this.userPreviousCheck}
            newArray={this.state.newArray}
          />
        </Modal>
        <Modal
          isOpen={this.state.shwAdminAnalystExisting}
          title='Add users'
          onClose={() => {
            this.setState({
              shwAdminAnalystExisting: false,
            });
          }}>
          <AddExistingUser
            botId={this.props.selectedBotid}
            src={this.state.shwAdminAnalystExisting ? 'team-tab' : ''}
            closeModal={(msg: string) => {
              if (msg === 'Users added') {
                this.setState({
                  shwAdminAnalystExisting: false,
                  showSelectionOfUser: false,
                });
                this.props.toasterNotify(msg);
                this.fetchAgentList();
              }
            }}
            closeModals={(val: boolean) => {
              this.setState({
                shwAdminAnalystNewUser: val,
              });
            }}
            tenantId={this.props.tenantId}
          />
        </Modal>
        <Modal
          isOpen={this.state.editRoleModal}
          title='Edit role'
          onClose={() => {
            this.setState({
              editRoleModal: !this.state.editRoleModal,
            });
          }}>
          <EditUserModal
            userDetails={this.state.editUserDetails}
            onCancel={() => {
              this.setState({
                editRoleModal: !this.state.editRoleModal,
              });
            }}
            onSave={(data: string, msg: string) => {
              this.saveEditDetails(data, msg);
            }}
            origin={this.state.editOrigin}
            botId={this.props.selectedBotid}
            editedAgentId={this.state.editAgent}
          />
        </Modal>
        <Modal
          title='Remove user'
          isOpen={this.state.shwDeleteModal}
          onClose={() => {
            this.setState({
              shwDeleteModal: !this.state.shwDeleteModal,
            });
          }}>
          <DeleteUserModal
            userName={this.state.deteleUser}
            RemoveUser={() => {
              this.RemoveUser();
            }}
            onClose={() => {
              this.setState({
                shwDeleteModal: !this.state.shwDeleteModal,
              });
            }}
            origin={this.state.deleteOrigin}
          />
        </Modal>
      </>
    );
  }
}
